// extracted by mini-css-extract-plugin
export default {"Wrapper":"Layout_Wrapper__tFDxV","main-content":"Layout_main-content__M0xWj","nav-hide":"Layout_nav-hide__PF28b"};